import compose from 'recompose/compose';
import { withModel } from '../../data-providers/model';
import Header from './Header';
import withMediaQueries from '../../hocs/withMediaQueries';

const enhance = compose(
  withModel,
  withMediaQueries
);

export default enhance(Header);
